import constants from '@/store/client/constants/client';

export default {
  [constants.setCompanyName](context, payload) {
    context.commit(constants.setCompanyName, payload);
  },
};
